import styled from "styled-components";
import { GrayColors, Colors } from "@smartsuite/types";

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  span {
    display: flex;
    width: 100%;
    padding-left: 20px;
    &.li {
      padding-left: 20px;

      &::before {
        content: "•";
        padding-right: 8px;
        font-weight: 600;
      }
    }
  }
`;

export const StyledRequestList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 30px;
  padding-top: 20px;
  padding-bottom: 20px;
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 6px;
  align-items: center;
`;

export const StyledListeningCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-top: 30px;
  padding: 20px;
  border: 1px solid ${GrayColors["G-1-5"]};
  border-radius: 6px;
`;

export const StyledListeningText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;

  > * {
    justify-content: center;
  }
`;

export const StyledRequestListHeader = styled.div`
  display: flex;
  font-weight: 500;
  color: ${Colors.custom15};
`;

export const StyledRequestListSubHeader = styled(StyledRequestListHeader)`
  font-weight: 400;
  font-size: 13px;
`;
export const StyledRequestListRefreshBtn = styled(StyledRequestListHeader)`
  font-weight: 400;
  padding-left: 4px;
  cursor: pointer;
  text-decoration: underline;
`;

export const StyledRequestListSelect = styled.div`
  display: flex;
  width: 100%;
  padding: 20px;
`;

export const StyledRequestSelectedItem = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 25px;
  width: 100%;
  span {
    display: flex;
    width: 100%;
  }
  button {
    display: flex;
    width: fit-content;
    margin-top: 10px;
  }
`;

export const DropdownOption = styled.div`
  .checkmark-option {
    height: 32px;
  }
  svg {
    margin-right: 10px;
  }
  span {
    font-weight: 500;
    vertical-align: top;
  }
`;

export const RadioOptionLabel = styled.div`
  display: flex;
  padding: 8px 10px 4px 7px;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
`;

export const RadioOptionSubLabel = styled(RadioOptionLabel)`
  padding: 4px 10px 8px 7px;
  font-size: 11px;
  line-height: 16px;
`;

export const StyledInfoSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 30px;
  padding: 9px 15px;
  color: ${Colors.custom15};
  background-color: ${Colors.custom17};
  border-radius: 5px;

  span {
    display: flex;
    align-items: center;
    gap: 15px;
  }
`;

export const StyledInfoSectionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  color: ${Colors.custom15};
`;

export const StyledRequestListError = styled.div`
  color: ${Colors.bRed};
  font-size: 12px;
  margin-top: 5px;
`;
